import * as YUP from "yup";

export const LoginDetailsSchema = YUP.object({
  course: YUP.string().min(3).max(25).required("*Please select a course"),
  roll_no: YUP.string().required("*Please enter your roll number"),
  dob: YUP.string().required("*Please enter your date-of-birth"),
  captcha: YUP.string().min(4).required("*Please enter the captcha"),
});
